__turbopack_context__.v({
  "addToCartButtonWrapper": "mXo8MG_addToCartButtonWrapper",
  "blurOverlay": "mXo8MG_blurOverlay",
  "blurredInfoWrapper": "mXo8MG_blurredInfoWrapper",
  "currentPrice": "mXo8MG_currentPrice",
  "lowestPrice": "mXo8MG_lowestPrice",
  "oldPrice": "mXo8MG_oldPrice",
  "productBrand": "mXo8MG_productBrand",
  "productCardContent": "mXo8MG_productCardContent",
  "productCardWrapper": "mXo8MG_productCardWrapper",
  "productDetails": "mXo8MG_productDetails",
  "productImage": "mXo8MG_productImage",
  "productInfo": "mXo8MG_productInfo",
  "productName": "mXo8MG_productName",
  "productPriceWrapper": "mXo8MG_productPriceWrapper",
  "productUnit": "mXo8MG_productUnit",
  "promoPercentTag": "mXo8MG_promoPercentTag",
  "userUnderage": "mXo8MG_userUnderage",
});
